var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from 'react';

function SvgShield(props) {
  return React.createElement("svg", __assign({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M8.398 19.462a.889.889 0 01-.796 0 19.969 19.969 0 01-3.743-2.57C1.463 14.793 0 12.416 0 9.777V2.667c0-.408.278-.764.673-.863L7.784.027a.889.889 0 01.432 0l7.11 1.777a.889.889 0 01.674.863v7.11c0 2.64-1.463 5.017-3.86 7.114a19.969 19.969 0 01-3.742 2.57zm.242-2.188a18.213 18.213 0 002.33-1.72c2.048-1.793 3.252-3.75 3.252-5.776V3.36L8 1.805 1.778 3.361v6.417c0 2.027 1.204 3.983 3.252 5.775A18.213 18.213 0 008 17.656c.197-.112.411-.24.64-.382z",
    id: "shield_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("mask", {
    id: "shield_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#shield_svg__a"
  })), React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#shield_svg__a"
  }), React.createElement("g", {
    mask: "url(#shield_svg__b)",
    fill: "#FFF"
  }, React.createElement("path", {
    d: "M-2.667-.889h21v21h-21z"
  }))));
}

export default SvgShield;